import React from 'react';
import './PriceListTier.css';

class PriceListTier extends React.Component {
  render() {
    return (
        <div className="row">
            <div className="col-md-10 col-md-offset-1">
                <div className="pricelist-tier title">
                    <div className="row">
                        <div className="col-md-6">
                            {this.props.name}
                        </div>
                    </div>
                </div>
                <div className="pricelist-tier tag">
                    Precio por caso
                </div>
                <div className="pricelist-tier price text-center">
                    <sub className="exponential">$</sub>{this.props.price}<sub className="exponential">00</sub>
                </div>
                <div>
                    <p className="pricelist-tier includes">
                        Incluye:
                    </p>
                    <p className="pricelist-tier includes">
                        Hasta {this.props.aligners} alineadores
                        Retenedores
                        Escaneo o materiales
                        de impresión
                    </p>
                </div>
                <div>
                    <p className="pricelist-tier includes">
                        Alineadores para reajustar
                        post-tratamiento, ilimitado por 1 año.
                    </p>
                </div>
                <div>
                    <p className="pricelist-tier includes">
                        IVA incluido
                    </p>
                </div>
                <div>
                    <hr className="pricelist-tier line"></hr>
                </div>
                <div>
                    Nuestro precio recomendado a los
                    pacientes es {this.props.recommendedPrice} MXN
                </div>
            </div>
        </div>



    );
  }

}

export default PriceListTier;



// WEBPACK FOOTER //
// ./src/views/Components/Presentation/PriceListTier/PriceListTier.js